import React from 'react';

import API from '@utils/API';
import CombinationDetails from '@components/Combinations/Details';
import { apiUrls } from '@constants/api';
import Helpers from '@utils/Helpers';
import { redirectTo } from '@components/RouterHelpers/redirectTo';
import routes from '@constants/routes';

const CombinationDetailsPage = props => <CombinationDetails {...props} />;

CombinationDetailsPage.getInitialProps = async ctx => {
  const { query, store } = ctx;

  const {
    conditions: { conditionsList }
  } = store.getState();

  const condition = conditionsList.find(i => i.slug === query.condition);

  if (!condition) {
    redirectTo(ctx.res, routes.pageNotFound, 404);
    return;
  }

  try {
    const { data } = await API.get(apiUrls.combinations.details(query.id));
    return {
      __meta__: {
        title: 'Success story'
      },
      combination: data
    };
  } catch (err) {
    Helpers.serverErrorHandler(err, ctx);
  }
};

export default CombinationDetailsPage;
